import { render, staticRenderFns } from "./IcoDashboardContract.vue?vue&type=template&id=ed92bdac&lang=html"
import script from "./IcoDashboardContract.vue?vue&type=script&lang=js"
export * from "./IcoDashboardContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports